const header = {
  1: {
    funnel: {
      title: "Simula tu Hipoteca",
      desc: "",
    },
    afford: {
      title: "¿Qué casa me puedo permitir?",
      desc: "",
    },
  },
  2: {
    funnel: {
      title: "¡Felicidades!",
      desc: "",
    },
    afford: {
      title: "¿Qué casa te puedes permitir?",
      desc: "Importe óptimo de compra de vivienda",
    },
  },
  3: {
    afford: {
      title: "¿Qué casa te puedes permitir?",
      desc: "Datos personales para realizar la solicitud",
    },
  },
  4: {
    afford: {
      title: "¡Felicidades!",
      desc: "",
    },
  },
};

export const uiModule = {
  namespaced: true,
  state: {
    type: null,
    step: 0,
    totalSteps: {
      afford: 4,
      funnel: 2,
    },
    results: false,
    loading: false,
  },
  mutations: {
    SET_TARGET_MORTGAGE: (state, type) => {
      state.type = type;
    },
    SET_STEP: (state, step) => {
      state.step = step;
    },
    SET_RESULTS: (state, results) => {
      state.results = results;
    },
    CLEAR_ALL: (state) => {
      state.type = null;
      state.step = 1;
    },
    SET_LOADING: (state, isLoading) => {
      state.loading = isLoading;
    },
  },
  getters: {
    all: (state) => {
      return state;
    },
    header: (state) => {
      return header[state.step];
    },
    type: (state) => {
      return state.type;
    },
    step: (state) => {
      return state.step;
    },
    totalSteps: (state) => {
      return state.totalSteps;
    },
    results: (state) => {
      return state.results;
    },
  },
};
